var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-content reward-tab-content" }, [
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("top"),
        attrs: { id: "top" }
      },
      [
        _c("top", {
          attrs: { currentTab: _vm.tab },
          on: { checkData: _vm.checkData }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("affiliater-list"),
        attrs: { id: "affiliater-list" }
      },
      [_c("affiliater-list", { attrs: { currentTab: _vm.tab } })],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "tab-pane",
        class: _vm.activeTab("reward-info"),
        attrs: { id: "reward-info" }
      },
      [_c("reward-info", { attrs: { currentTab: _vm.tab } })],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a4ade32", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a4ade32","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/affiliate/TabContent.vue
// module id = null
// module chunks = 